import { Injectable } from '@angular/core';
import { HttpParameterCodec } from '@angular/common/http';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class LocaStockService {
  private apiUrl = '/locastocks';
  private apiSpringUrl = '/spring/locastocks';
  private apiSpringUrl2 = '/spring/moves/locastocks';

  constructor(private http: HttpService) { }

  get(
    viewMode: number,
    itemId: number,
    ownerId: number,
    locaCd: string,
    itemCd: string,
    deadlinedaysNr: number,
    typestockCd: string
  ): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    let padd = false;
    if ((viewMode === 1) || (viewMode === 2)) {
      url += '?stockSts='+viewMode;
      padd = true;
    }
    if (itemId > 0) {
      url += (padd?'&':'?')
      url += ('itemId=' + itemId);
      padd = true;
    }
    if (ownerId > 0) {
      url += (padd?'&':'?')
      url += ('ownerId=' + ownerId);
      padd = true;
    }

    if (locaCd != null && locaCd.length > 0) {
      url += (padd?'&':'?')
      url += ('locaCd=' + encodeURIComponent(locaCd));
      padd = true;
    }

    if (itemCd != null && itemCd.length > 0) {
      url += (padd?'&':'?')
      url += ('itemCd=' + encodeURIComponent(itemCd));
      padd = true;
    }

    if (deadlinedaysNr != null) {
      url += (padd?'&':'?')
      url += ('deadlinedaysNr=' + encodeURIComponent(deadlinedaysNr.toString()));
      padd = true;
    }

    if (typestockCd != null && typestockCd.length > 0) {
      url += (padd?'&':'?')
      url += ('typestockCd=' + typestockCd);
      padd = true;
    }

    return this.http.get(url);
  }

  getMoveSrc(
    viewMode: number,
    itemId: number
  ): Promise<any> {
    let url = '';
    if (viewMode === 1) {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl2 + '?isItemId=1'}`;
      if (itemId !== 0) {
        url += '&itemId=' + itemId;
      }
    } else if (viewMode === 2) {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl + '?isItemId=2'}`;
      if (itemId !== 0) {
        url += '&itemId=' + itemId;
      }
    } else {
      url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}`;
      if (itemId !== 0) {
        url += '?itemId=' + itemId;
      }
    }
    return this.http.get(url);
  }

  getMoveDest(
    itemId: number,
    locaId: number,
    lotTx: string
  ): Promise<any> {
    let url = environment.baseUrl + sessionStorage.getItem('baseUrlCompany') + this.apiSpringUrl2
      + '?mItemId=' + itemId + '&mLocaId=' + locaId;

      if (lotTx !== undefined) {
        url += '&mLotTx=' + lotTx;
      }

    return this.http.get(url);
  }

  getOnlyP(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/p';
    return this.http.get(url);
  }

  post(
    originalDt: string,
    bookDt: string,
    locaId: number,
    itemId: number,
    lotTx: string,
    uselimitDt: string,
    stockDt: string,
    stockNr: number,
    typeoperationCd: string,
    stockinoutmemoTx: string,
    updprogramCd: string,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${locaId}`;
    const jsonInput = {
      originalDt: originalDt,
      bookDt: bookDt,
      itemId: itemId,
      lotTx: lotTx,
      uselimitDt: uselimitDt,
      stockDt: stockDt,
      stockNr: stockNr,
      typeoperationCd: typeoperationCd,
      stockinoutmemoTx: stockinoutmemoTx,
      updprogramCd: updprogramCd,
    };

    return this.http.post(url, jsonInput);
  }

  put(
    originalDt: string,
    bookDt: string,
    locastockpId: number,
    updstockNr: number,
    typeoperationCd: string,
    stockinoutmemoTx: string,
    updprogramCd: string,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${locastockpId}`;
    const jsonInput = {
      originalDt: originalDt,
      bookDt: bookDt,
      updstockNr: updstockNr,
      typeoperationCd: typeoperationCd,
      stockinoutmemoTx: stockinoutmemoTx,
      updprogramCd: updprogramCd,
    };

    return this.http.put(url, jsonInput);
  }

  updTypeStock(
    srclocastockpId: number,
    pcsNr: number,
    destlocaId: number,
    memoTx: string,
    updprogramCd: string,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiUrl}/typestock/${srclocastockpId}`;
    const jsonInput = {
      pcsNr: pcsNr,
      destlocaId: destlocaId,
      memoTx: memoTx,
      updprogramCd: updprogramCd,
    };

    return this.http.put(url, jsonInput);
  }

  recombine(data: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/recombine`;
    return this.http.put(url, data);
  }

  updStockMemo(
    details: object[],
    ownerId: number,
    notapplyFl: number,
    memoTx: string,
    updprogramCd: string,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/memo/upd`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < details.length; i++) {
      jsonUnit.push({
        locastockpId: details[i]['selectId']
      });
    }
    const jsonInput = {
      details: jsonUnit,
      ownerId: ownerId,
      notapplyFl: notapplyFl,
      memoTx: memoTx,
      updprogramCd: updprogramCd,
    };
    return this.http.put(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/loca-stock/loca-stock.service.ts